import { useRef, useState } from "react";
import DetailsProductSection from "./details-product-section";
import FillFormSection from "./fill-form-section";

function PhuBaoAnGiaProduct ({objectDto, setObjectDto, setIsLoading, targetDivRef, confirm, setConfirm}) {
    const [status, setStatus] = useState(false);
    return (
        <>
            <FillFormSection objectDto={objectDto} setIsLoading={setIsLoading} setStatus={setStatus} setObjectDto={setObjectDto} confirm={confirm} setConfirm={setConfirm} />
            <DetailsProductSection status={status} setIsLoading={setIsLoading} objectDto={objectDto} setObjectDto={setObjectDto} targetRef={targetDivRef}/>
        </>
    );
}

export default PhuBaoAnGiaProduct;